import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100" aria-label="行动号召">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-4">
            准备好让品牌传播更有价值了吗？
          </h2>
          <p className="text-foreground-600 leading-relaxed mb-8 md:mb-10 max-w-xl mx-auto">
            无论您是初创品牌还是成熟企业，黄瓜传媒都能为您提供量身定制的传播解决方案
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap shadow-lg shadow-primary-500/20"
            >
              预约咨询
            </Link>
            <a
              href="tel:400-888-6666"
              className="px-8 py-3.5 rounded-full bg-background-200/70 text-foreground-700 font-medium text-sm hover:bg-background-300/70 transition-colors whitespace-nowrap border border-background-300/60"
            >
              <span className="inline-flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </span>
                400-888-6666
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}